import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { IRole } from '@models/Interface/IRole';

export class RolesService {
    static async fetch(): Promise<AxiosResponse<IRole[]>> {
        return $api.get<IRole[]>('/AccessGroups');
    }
}
